module.exports = __webpack_public_path__ + "static/map_usa_WE_hover-4ef412c43aef42255a961b6a9de8c07c.png";